import { Component, EventEmitter, Output, Input, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import { MatLegacyMenuTrigger as MatMenuTrigger} from "@angular/material/legacy-menu";

import { ProfileDialogComponent } from "../profile";
import { ChangePasswordDialogComponent } from "../changePassword";

import { AuthenticationService, MediaWatcherService } from "../_services";
import { IUser } from "../_models";

@Component({
    selector: "app-toolbar",
    templateUrl: "toolbar.component.html",
    styleUrls: ["toolbar.component.css"]
})
export class ToolbarComponent implements OnInit, OnDestroy {
    @Output() toggleSideNav = new EventEmitter<any>();
    @Input() sideNavOpened = false; 

    currentUser: IUser;
    currentUserSubscription: Subscription;
    mediaWatcherSubscription: Subscription;

    isMobile = false;

    @ViewChild("notificationsMenuTrigger", {static: true}) trigger: MatMenuTrigger;

    constructor(private authenticationService: AuthenticationService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router, private mediaWatcherService: MediaWatcherService) {
    }

    ngOnInit() {
        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;

            this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
                this.isMobile = isMobile;
            });

            if (this.currentUser && this.currentUser.userNotifications.length > 0) {
                setTimeout(() => {
                    var notifications = this.currentUser.userNotifications.filter(f => !f.viewed);

                    if (notifications.length > 0) {
                        this.trigger.openMenu();

                        notifications.forEach(f => f.viewed = true);
                    }
                }, 0);
            }
        });
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    logout() {
        this.authenticationService.logout(false);
    }

    accountProfile() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.panelClass = "popup-dialog-container";
        dialogConfig.height = "auto";
        dialogConfig.maxWidth = "100%";
        dialogConfig.width = this.isMobile ? "85%" : "75%";
        
        dialogConfig.data = {
            currentUser: this.currentUser
        };

        this.dialog.open(ProfileDialogComponent, dialogConfig);
    }

    changePassword() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.height = "290px";
        dialogConfig.panelClass = "popup-dialog-container";
        dialogConfig.maxWidth = "100%";
        dialogConfig.width = this.isMobile ? "85%" : "35%";

        dialogConfig.data = {
            studentRegistrationId: this.currentUser.id
        };

        this.dialog.open(ChangePasswordDialogComponent, dialogConfig);
    }

    notificationRedirect(userNotification: any) {
        if (userNotification.dialogBox) {
            userNotification.viewed = true;

            this[userNotification.dialogBox]();
        }

        if (userNotification.url) {
            userNotification.viewed = true;

            this.router.navigate([userNotification.url]);
        }
    }

    sideNavToggle() {
        this.sideNavOpened = !this.sideNavOpened;

        const data = {
            opened: this.sideNavOpened,
            //isMobile: this.isMobile
        };

        this.toggleSideNav.emit(data);
    }
}

